import { BusinessSource, UpdateBusinessSource } from '@/entities/businessSource';
import { Api } from './api/axios-config';

export class BusinessSourceService {
  private static api = Api();
  public static async createBusinessSourceService(businessSource:BusinessSource){
    const response = await this.api.post<any>('/business-source', {description:businessSource.description});
    if(response.status === 201){
      return {
        id:response.data.id,
        description: response.data.id,
        contactNumber: response.data.contactNumber
      };
    }
    return null;
  }

  public static async getBusinessSourceService(){
    const response = await this.api.get<any>('/business-source');
    if(response.status === 200){
      return response.data.map((data:any)=>({
        id: data.id,
        description: data.description,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt,
      }));
    }
    return null;
  }

  public static async updateOrCreateBusinessSource(businessSource:UpdateBusinessSource[]){
    const response = await this.api.put<any>('/business-source', {businessSource});
    if(response.status === 200){
      return response.data.map((data:any)=>({
        id: data.id,
        description: data.description,
        contactNumber:data.contactNumber,
        createdAt: data.createdAt,
        updatedAt: data.updatedAt,
      }));
    }
    return null;
  }
    
  public static async deleteBusinessSource(id: number){
    const response = await this.api.delete<any>(`/business-source/${id}`);
    if(response.status === 200){
      return {
        id: response.data.id,
        description: response.data.description,
      };
    }
    return null;
  }

  public static async searchBusinessSource(contain:string){
    const response = await this.api.post<any>('/business-source/search',{contain});
    if(response.status === 201){
      return response.data.map((data:any) =>({
        id:data.id,
        contactNumber: data.contactNumber,
        description:data.description
      }));
    }
    return null;
  }

}
